<template>
  <v-card>
    <v-card-title>
      List of Inactive Customer Accounts ({{ items.length }})
      <v-btn small icon @click.native="dataRefresh">
       <v-icon>refresh</v-icon></v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        append-icon="search"
        label="Search"
        single-line
        hide-details
        v-model="search">
      </v-text-field>
    </v-card-title>
    <v-progress-linear
      :indeterminate="true"
      :active="showProgress">
    </v-progress-linear>
    <v-data-table
      v-bind:headers="headers"
      v-bind:items="items"
      v-bind:search="search"
      v-bind:rows-per-page-items="rowsPerPage">
      <template slot="items" slot-scope="props">
        <td class="layout px-0">
          <v-btn small icon :to="{name: 'customerAccountEdit', params: { id: props.item.customerAccountId }}">
            <v-icon small color="grey">more_horiz</v-icon></v-btn></td>
        <td class="text-xs-left">{{ props.item.customerName}}</td>
        <td class="text-xs-left">
          <v-expansion-panel popout>
            <v-expansion-panel-content>
              <div slot="header">{{ props.item.address.unitNumber}} {{ props.item.address.streetAddress}}</div>
              <v-card class="grey lighten-4 pl-2, pr-2, mt-1, mb-1">
                <v-card-text>
                  {{ props.item.address.city}}
                </v-card-text>
                <v-card-text>
                  {{ props.item.address.province}}
                </v-card-text>
                <v-card-text>
                  {{ props.item.address.postalCode}}
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </td>
        <td class="text-xs-left">{{ props.item.phone.phone }}</td>
        <td class="text-xs-left">{{ props.item.email.email }}</td>
        <td class="text-xs-left">
          <v-expansion-panel popout>
            <v-expansion-panel-content>
              <div slot="header">{{ props.item.contact.firstName }} {{ props.item.contact.lastName }}</div>
              <v-card class="grey lighten-4 pl-2, pr-2, mt-1, mb-1">
                <v-card-text>
                  Phone: {{ props.item.contact.phone.phone}}
                </v-card-text>
                <v-card-text>
                  Email: {{ props.item.contact.email.email}}
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </td>
        <td class="text-xs-left">
          <v-dialog v-model="dialog" max-width="500px" hide-overlay lazy>
            <v-btn small icon slot="activator" @click.native="
              deleteId = props.item.customerAccountId,
              deleteName = props.item.customerName,
              dialog = true">
              <v-icon small color="grey">redo</v-icon>
            </v-btn>
            <v-card>
              <v-card-text>
                Do you want to set the account
                <div class="red--text subheading">
                    {{ deleteName }}
                </div>to active
              </v-card-text>
              <v-spacer></v-spacer>
              <v-btn dark color="blue darken-1"
                @click.native="dialog = false">CANCEL</v-btn>
              <v-btn dark color="red darken-1"
              @click.native="reactivate()">CONFIRM ACTIVE</v-btn>
            </v-card>
          </v-dialog>
        </td>
      </template>
      <template slot="pageText" slot-scope="{ pageStart, pageStop }">
        From {{ pageStart }} to {{ pageStop }}
      </template>
    </v-data-table>
    <div class="red white--text subheading">{{ errMsg }}</div>
  </v-card>
</template>

<script>
  import mixins from '@/mixins.js'
  import CustomerAccountService from '@/services/CustomerAccountService'

  export default {
    data () {
      return {
        errMsg: '',
        deleteId: 0,
        deleteName: '',
        showProgress: true,
        dialog: false,
        tmp: '',
        search: '',
        selected: [],
        pagination: {},
        rowsPerPage: [
          10,
          20,
          {"text": "All", "value": -1}
        ],
        headers: [
          { text: 'Edit',
            align: 'left',
            sortable: false
          },
          { text: 'Customer Name', align: 'left', value: 'customerName' },
          { text: 'Address', align: 'left', value: 'address.streetAddress' },
          { text: 'Phone', align: 'left', value: 'phone.phone' },
          { text: 'Email', align: 'left', value: 'email.email' },
          { text: 'Contact', align: 'left', value: 'contact.firstName'},
          { text: 'Re-activate',
            align: 'left',
            sortable: false
          }
        ],
        items: []
      }
    },
    mixins: [mixins],
    async mounted () {
      try {
        this.dialog = false
        this.errMsg = ''
        this.showProgress = true
        this.items = (await CustomerAccountService.index({state: 1})).data
        this.showProgress = false
      } catch (error) {
        this.showProgress = false
        this.errMsg = this.handleError(error)
      }
    },
    methods: {
      async reactivate() {
        try {
          this.errMsg = ''
          this.dialog = false
          const response = await CustomerAccountService.state({
            customerAccountId: this.deleteId,
            state: 0
          })
          this.showProgress = true
          this.items = (await CustomerAccountService.index({state: 1})).data
          this.showProgress = false
        } catch (error) {
          this.showProgress = false
          this.errMsg = this.handleError(error)
        }
      },
      async dataRefresh() {
        try {
          this.errMsg = ''
          this.dialog = false
          this.showProgress = true
          this.items = (await CustomerAccountService.index({state: 1})).data
          this.showProgress = false
        } catch (error) {
          this.showProgress = false
          this.errMsg = this.handleError(error)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/CustomerAccount/CustomerAccountListInactive.vue